<script setup>
import GuestLayout from '@/Layouts/GuestLayout.vue';
import { Head, useForm } from "@inertiajs/vue3";

const form = useForm({
    email: '',
    password: '',
});

const submit = () => {
    form.post(route('login'), {
        onFinish: () => form.reset('password'),
        onSuccess: () => {
            window.location.reload();
        }
    });
};

</script>

<template>
    <GuestLayout>
        <Head title="Login" />
        <form
            class="dynamic-width"
            @submit.prevent="submit"
        >
            <v-row class="mt-6">
                <v-col>
                    <strong class="text-primaryHighlight font-size-20">Log In</strong>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-text-field
                        v-model="form.email"
                        class="mb-3"
                        name="email"
                        label="Email Address"
                        :error-messages="form.errors.email"
                        outlined
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-text-field
                        v-model="form.password"
                        class="mb-0"
                        name="password"
                        label="Password"
                        hide-details
                        outlined
                        :error-messages="form.errors.password"
                        type="password"
                    >
                    </v-text-field>
                    <a :href="route('password.request')"><small>Forgotten your password?</small></a>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <div class="text-center mb-6">
                        <v-btn
                            type="submit"
                            class="login"
                            color="primaryHighlight"
                            append-icon="far fa-right-to-bracket"
                            text="Log In"
                        />
                    </div>
                </v-col>
            </v-row>
            <v-row
                v-if="isSouthEast()"
                class="my-6 d-flex dynamic-alignment"
            >
                <v-col
                    cols="4"
                    class="d-flex align-start"
                >
                    <v-img
                        src="static/images/bracknell_forest_council.png"
                        alt="Bracknell Forest Council"
                    />
                </v-col>
                <v-col
                    cols="8"
                    class="pb-6"
                >
                    <strong class="text-primaryHighlight font-size-20">Bracknell Forest Single Sign-On</strong>
                    <div class="text-left my-3">
                        <v-btn
                            :href="route('sso-login.local-authority', 'bracknell-forest')"
                            append-icon="far fa-right-to-bracket"
                            text="Single Sign-On"
                        />
                    </div>
                </v-col>
            </v-row>
        </form>
    </GuestLayout>
</template>

<style scoped>
.dynamic-width {
    width: 25% !important;
}

.dynamic-alignment {
    align-items: flex-end;
}

@media only screen and (max-width: 768px) {
    .dynamic-width {
        width: 75% !important;
    }

    .dynamic-alignment {
        align-items: center;
    }
}
</style>
